import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild  } from '@angular/core';
import { MatSelect } from '@angular/material';
import { Subscription } from 'rxjs';
import { EditCodeSatService } from '../../services/edit-code-sat.service';
import { generalService } from '../../services/general.service';

@Component({
  selector: 'app-edit-code-sat',
  templateUrl: './edit-code-sat.component.html',
  styleUrls: ['./edit-code-sat.component.scss'],
  providers: [generalService]
})
export class EditCodeSatComponent implements OnInit , OnDestroy, OnChanges {
  //public matOptions: any;
  @ViewChild('infiniteSelect') selectElem: MatSelect;
  @Input() product : any ;
  @Input() enabled : boolean = false ;
  @Output() changeCode : EventEmitter<any> = new EventEmitter();
  ref: Subscription;
  
  public viewDataProduct: any[];
private arrayFilteredSat = undefined;
public filtroSATCodes: any[];
private itemsShow = 10;
private filteredItemsShowSat = 10;
private isFilteredSat = false;

constructor(private _editCodeSatService : EditCodeSatService ) { 
    this.ref = this._editCodeSatService.matOptions$.subscribe(data=>{
      //this.matOptions = data;
      this.moverSeleccion();
    });
    if(this._editCodeSatService.matOptions.SATcodes != undefined){
      this._editCodeSatService.emitMatOptions();
    }
  }
 
  ngOnChanges(changes: SimpleChanges) {
    if(changes.product)
    {
       this.product = changes.product.currentValue;
       this.moverSeleccion();
       
    }
 
  }
  async ngOnInit() {
   
    
  }

  // public trackItem (index: number, item: any) {
  //   return item.trackId;
  // }

  registerPanelScrollEvent() {
    const panel = this.selectElem.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
  }

  loadAllOnScroll(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if(this.isFilteredSat) {
        if(this.filteredItemsShowSat < this.arrayFilteredSat.length) {
            this.filteredItemsShowSat += 10;
            this.viewDataProduct = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
        }
      } else {
        if(this.itemsShow < this._editCodeSatService.matOptions.SATcodes.length) {
          this.itemsShow += 10;
          this.viewDataProduct = this._editCodeSatService.matOptions.SATcodes.slice(0, this.itemsShow);
        }
      }
    }
  }

  emitNewCode(code:any){
    this.changeCode.emit([this.product.itemId,code.value]);
  }

  moverSeleccion() {
    /***************************INFINITE SELECT**********************************/
    if(this.product!= undefined && this._editCodeSatService.matOptions.SATcodes != undefined)
    {
      const index = this._editCodeSatService.matOptions.SATcodes.findIndex(x => x.itemSATcodeId == this.product.ITEM_SAT_ID);
      var a = this._editCodeSatService.matOptions.SATcodes.splice(index,1);
      this._editCodeSatService.matOptions.SATcodes.unshift(a[0]);
    
      this.viewDataProduct = this._editCodeSatService.matOptions.SATcodes.slice(0, 10);
    }
    
    /***************************INFINITE SELECT**********************************/
  }

  
  onKeyUpSATcode(val: any) {
    let arr: any[];
    if (val.currentTarget.value != "") {
      this.arrayFilteredSat = this._editCodeSatService.matOptions.SATcodes.filter((obj:any) => {
        return (obj.SATcode.includes(val.currentTarget.value) > 0 || obj.DESCRIPTION.toLowerCase().includes(val.currentTarget.value.toLowerCase()));
      })

      arr = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
      this.isFilteredSat = true;
    } else {
      /***************************INFINITE SELECT**********************************/
      // arr = this.filtroSATCodes;
      this.isFilteredSat = false;
      this.filteredItemsShowSat = 10;
      this.arrayFilteredSat = undefined;
      arr = this._editCodeSatService.matOptions.SATcodes.slice(0, this.itemsShow);
      /***************************INFINITE SELECT**********************************/
    }
    /***************************INFINITE SELECT**********************************/
    //this.matOptions.SATcodes = arr;
    this.viewDataProduct = arr;
    //this.changeDetection.detectChanges();
    /***************************INFINITE SELECT**********************************/
  }
  
  ngOnDestroy(): void {
    this.ref.unsubscribe();
  }




}



// WEBPACK FOOTER //
// ./src/app/product/edit-code-sat/edit-code-sat.component.ts